import { Tooltip } from '@material-ui/core';
import LabelIcon from '@material-ui/icons/Label';
import { getColorByUnicode } from '../../utils/functions';
import NoIcon from '../common/no-icon';

interface CohortIconProps {
  label?: string;
}

function CohortIcon({ label }: CohortIconProps) {
  if (!label) {
    return <NoIcon />;
  }

  return (
    <Tooltip title={label} enterTouchDelay={0} placement={'top'}>
      <LabelIcon htmlColor={getColorByUnicode(label)} />
    </Tooltip>
  );
}

export default CohortIcon;
